import React from "react";
import { CSVLink, CSVDownload } from "react-csv";
import { Assessment3FuelTypeInfo } from "../state";
import { Assessment3HHDataReceivedStatusEnum } from "../state";

interface Assessment3DownloadCSVProps {
    fuelTypes: Assessment3FuelTypeInfo[];
}

function Assessment3DownloadCSV({ fuelTypes }: Assessment3DownloadCSVProps) {
    
    const csvData = [["Fuel", "Issue", "Action Plan"]];
        let rowIndex:number = 1;
        //iterate fuel types
        fuelTypes.map(fuel => {
            if(fuel.appIncludesMainHeatingTypeDesc != null && fuel.appIncludesMainHeatingTypeDesc != '')
              {
                  csvData[rowIndex] = [fuel.description
                                        ,"Grant Recipients should ensure that their LIHEAP application includes a section for heating fuel type."
                                        , fuel.appIncludesMainHeatingTypeDesc];
                  rowIndex++; 
              }
            if(fuel.appIncludesVendorAndAcctNumDesc != null && fuel.appIncludesVendorAndAcctNumDesc != '')
              {
                  csvData[rowIndex] = [fuel.description
                                        ,"Grant Recipients need to ensure that their client applications require clients to include their account number with their" + fuel.descriptionHeat + "vendor."
                                        , fuel.appIncludesVendorAndAcctNumDesc];
                  rowIndex++; 
              }
            if(fuel.appIncludesClientWaiverDesc != null && fuel.appIncludesClientWaiverDesc != '')
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Grant Recipients should ensure that all of their LIHEAP applicants sign a waiver."
                                      , fuel.appIncludesClientWaiverDesc];
                rowIndex++; 
            }

            if(fuel.anyOtherIssuesAssignmentRateFlag === false)
            {
                  csvData[rowIndex] = [fuel.description
                    , 'Any other issues that may be impacting vendor assignment rate'
                    , fuel.anyOtherIssuesAssignmentRateDesc];
                  rowIndex++; 
            }

            if(fuel.householdsServedByVendorsProvidingDataStatusDesc != null && fuel.householdsServedByVendorsProvidingDataStatusDesc != '')
              {
                  csvData[rowIndex] = [fuel.description
                                        ,"Either request data from description vendors that represent a greater percentage of your LIHEAP clients OR request data from a larger number of description vendors."
                                        , fuel.householdsServedByVendorsProvidingDataStatusDesc];
                  rowIndex++; 
              }
            if(fuel.householdsServedByVendorsSelectedStatusDesc != null && fuel.householdsServedByVendorsSelectedStatusDesc != '')
              {
                  csvData[rowIndex] = [fuel.description
                                        ,"Either request data from a larger number of description vendors or find a way to compel the vendors from whom you originally requested data to comply with those data requests."
                                        , fuel.householdsServedByVendorsSelectedStatusDesc];
                  rowIndex++; 
              }
            if(fuel.rateOfReturnStatusDesc != null && fuel.rateOfReturnStatusDesc != '')
              {
                  csvData[rowIndex] = [fuel.description
                                        ,"Vendors are not submitting complete data for an adequate percentage of their households."
                                        , fuel.rateOfReturnStatusDesc];
                  rowIndex++; 
              }
            if(fuel.vendorsNotIncludeAllDataElementsDesc != null && fuel.rateOfReturnStatusDesc != '')
              {
                  csvData[rowIndex] = [fuel.description
                                        ,"Vendors are including all data elements."
                                        , fuel.vendorsNotIncludeAllDataElementsDesc];
                  rowIndex++; 
              }
            if(fuel.ableToMatchAccountsDesc != null && fuel.ableToMatchAccountsDesc != '')
            {
                csvData[rowIndex] = [fuel.description
                                      ,"IT staff need to be able to match main heating vendor accounts with description baseload or other accounts."
                                      , fuel.ableToMatchAccountsDesc];
                rowIndex++; 
            }

            if(fuel.dataReceivedStatus == Assessment3HHDataReceivedStatusEnum.NotMeetTarget)
            {
                let increaseDataDesc: string = '';
                if (fuel.increaseNumberOfVendorsSelectedFlag == true) {
                    increaseDataDesc+= 'Increase the number of vendors selected<br />';
                }
                if (fuel.increaseNumberOfVendorsProvidingFlag == true) {
                    increaseDataDesc+= 'Increase the number of vendors providing data<br />';
                }
                if (fuel.increaseRateOfReturnFlag == true) {
                    increaseDataDesc+= 'Increase the number of vendors providing data<br />';
                }
                increaseDataDesc+= fuel.increaseDataDesc;


                csvData[rowIndex] = [fuel.description
                                      , 'Action items to ensure that data received from an adequate number of households in the future'
                                      , increaseDataDesc];
                rowIndex++; 
            }                       
        });
    return (
      <CSVLink data={csvData} filename="MainHeatingFuelAssessment3.csv" className="dataButton">Download as CSV</CSVLink>
    );
}


export default Assessment3DownloadCSV;
